import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import React, { useState } from 'react';
import { CreateModal } from '../create-modal';
import styles from './actions.module.scss';
export const Actions = ({ primary, secondary, link, pageName, disabled, }) => {
    const { t } = useTranslation();
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const onDismiss = () => {
        setDeleteConfirm(false);
    };
    const onConfirm = () => {
        setDeleteConfirm(false);
        if (link.onClick) {
            link.onClick();
        }
    };
    return (React.createElement(React.Fragment, null,
        deleteConfirm && (React.createElement(CreateModal, { pageName: pageName, action: "delete", onDismiss: onDismiss, onConfirm: onConfirm })),
        React.createElement("div", { className: styles.actionContainer },
            React.createElement("div", { className: styles.buttonRow },
                React.createElement("div", { className: styles.innerContainer }, "\u00A0"),
                React.createElement("div", { className: styles.buttonSubmitContainer },
                    React.createElement(Button, { onClick: primary.onClick, text: primary.text, type: "primary", isDisabled: disabled }),
                    secondary && (React.createElement("div", { className: styles.cancelBtnMargin },
                        React.createElement(Button, { onClick: secondary.onClick, text: secondary.text, type: "secondary", isDisabled: disabled }))))),
            link && (React.createElement("div", { className: styles.buttonReset },
                React.createElement("div", { className: styles.innerContainer }, "\u00A0"),
                React.createElement("div", { className: styles.buttonResetContainer },
                    React.createElement(Link, { className: styles.resetUnderlineNone, onClick: () => {
                            if (link.askConfirm) {
                                setDeleteConfirm(true);
                            }
                            else if (link.onClick) {
                                link.onClick();
                            }
                        } }, link.text)))))));
};
//# sourceMappingURL=actions.js.map